import fx from "../../utils/fx";
import AxiosInterceptor from "api/interceptor";

const category = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return category.get("/category?" + qstr);
  },
  find(id) {
    return category.get("/category/" + id);
  },
  create(inputs) {
    return category.post("/category", {
      name: inputs.name,
      description: inputs.description,
      parent_id: inputs.parent_id,
      ord: inputs.ord
    });
  },
  update(id, inputs) {
    return category.put("/category/" + id + "/update", {
      name: inputs.name,
      description: inputs.description,
      parent_id: inputs.parent_id,
      ord: inputs.ord
    });
  },
  delete(id) {
    return category.delete("/category/" + id + "/delete");
  },
  addProduct(inputs) {
    return category.post("/category/add-product", {
      product_id: inputs.product_id,
      category_id: inputs.category_id
    });
  },
  removeProduct(inputs) {
    return category.post("/category/remove-product", {
      product_id: inputs.product_id,
      category_id: inputs.category_id
    });
  },
  sort(inputs) {
    return category.post("/category/sort", {
      ids: inputs.ids
    });
  },
  getTree(id = null) {
    return category.get("/category/tree" + (id ? "?id=" + id : ""));
  },
  searchOffer(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return category.get("/category/search?" + qstr);
  },
  getCategoryAddons() {
    return category.get("/category/product-add-ons");
  }
};
